define(['jquery', 'pluralize'], ($, pluralize) => {
    return $el => {
        const $container = $el || $(document);

        $container.find('.js-pluralize').each(function () {
            const $this = $(this);

            $this.html(
                pluralize({
                    value: $this.data('pluralize-value'),
                    text: $this.data('pluralize-text'),
                })
            );
        });
    };
});
